var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('choice-table',{attrs:{"width":"60%","api":"/api/sys/user/list","choiceType":_vm.choiceType,"searchField":[{ type: 'input', account: 'account', name: '用户编码' }],"tableColumns":[
    { code: 'userId', name: '用户编码' },
    { code: 'account', name: '账号' },
    { code: 'name', name: '姓名' },
    { code: 'deptName', name: '部门名称' },
    { code: 'phone', name: '手机号码' },
    { code: 'createDate', name: '创建日期' } ],"title":"请选择用户","dialogVisible":_vm.dialogVisible},on:{"close":function($event){return _vm.$emit('dialogVisibleClose', false)},"choiced":_vm.cs}})}
var staticRenderFns = []

export { render, staticRenderFns }